import { curryRight } from 'lodash-es';

import { nfCurrencyTransform } from '../../../../../../../../../frontend/libs/shared-vanilla/src/index';

// All logic for this filter has been moved into the new Angular codebase
// Currency formatting is still being handled by the angularJS currency filter hence the curry
export function NfCurrencyFilter($filter) {
  'ngInject';

  const currency: (
    value: number,
    symbol: string,
    decimals: number,
  ) => string = $filter('currency');

  const curried = (symbol, decimals) => {
    return curryRight(currency, 3)(decimals)(symbol);
  };

  //orginal call was value = currency(amount, symbol, decimals);
  return function (amount, symbol, decimals = 0) {
    if (!amount && amount !== 0) {
      return 'N/A';
    }

    return nfCurrencyTransform(amount, curried(symbol, decimals));
  };
}

export function NfCurrencyNumericFilter($filter) {
  'ngInject';

  const currency: (
    value: number,
    symbol: string,
    decimals: number,
  ) => string = $filter('currency');

  const curried = (symbol, decimals) => {
    return curryRight(currency, 3)(decimals)(symbol);
  };

  //orginal call was value = currency(amount, symbol, decimals);
  return function (amount, symbol, decimals = 0) {
    if (!amount && amount !== 0) {
      return '$0';
    }

    return nfCurrencyTransform(amount, curried(symbol, decimals));
  };
}
